import React from 'react';
import { BellIcon, HomeIcon, IdCardIcon, LayoutGridIcon, SparklesIcon, UserRoundIcon } from 'lucide-react';
import { citizenFirstName, mobileItems } from '../../data/espace';
export function PhoneMockup() {
  return <div aria-hidden="true" className="mx-auto w-[280px] rounded-[2.5rem] border-[10px] border-ville-navy bg-white shadow-2xl shadow-ville-navy/25" data-id="element-1562" data-mp="1s1i2vy60sm49">
      <div className="flex h-[560px] flex-col overflow-hidden rounded-[1.8rem]" data-id="element-1563" data-mp="2kpdyezjus7zg">
        <div className="flex items-center justify-between px-5 pt-5" data-id="element-1564" data-mp="2kn9skc2e8ywj">
          <span className="text-[15px] font-extrabold text-ville-navy" data-id="element-1565" data-mp="2pnfs0eewnpp6">Beaconsfield</span>
          <span className="relative grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-ville-navy" data-id="element-1566" data-mp="2aqeyq6h2fmol">
            <BellIcon className="h-4 w-4" data-id="element-1567" data-mp="2fo6r11lmhatb" />
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-red-600 ring-2 ring-white" data-id="element-1568" data-mp="zb9u2wxdje2c" />
          </span>
        </div>

        <div className="px-5 pt-5" data-id="element-1569" data-mp="14cfp51eibdf1">
          <p className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1570" data-mp="30lzzp09agkxn">Bonjour {citizenFirstName}</p>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2" data-id="element-1571" data-mp="2vn6kn3ecslvd">
            <SparklesIcon className="h-4 w-4 text-ville-indigo" data-id="element-1572" data-mp="39mg369q17s2i" />
            <span className="text-xs text-slate-400" data-id="element-1573" data-mp="39kld6gzwl9rk">Que puis-je faire pour vous ?</span>
          </div>
        </div>

        <div className="mt-5 flex-1 px-5" data-id="element-1574" data-mp="3jkvtwbl5czbh">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-1575" data-mp="3jju6r8quwmde">Pour vous</p>
          <ul className="mt-2.5 space-y-2.5" data-id="element-1576" data-mp="3ekpyckbraso4">
            <li className="rounded-2xl border-l-4 border-red-600 bg-slate-50 px-4 py-3" data-id="element-1577" data-mp="3ejybpz05059z">
              <p className="text-[11px] font-bold uppercase tracking-wider text-red-600" data-id="element-1578" data-mp="3sfa4w1yn9nos">Urgent</p>
              <p className="text-sm font-bold text-ville-navy" data-id="element-1579" data-mp="3odoxgw4vq1lz">Avis d’ébullition</p>
              <p className="text-xs text-slate-500" data-id="element-1580" data-mp="66hdxzje1871">Secteur du chemin Beaurepaire</p>
            </li>
            {mobileItems.map(item => <li key={item.id} className="rounded-2xl border border-slate-200 px-4 py-3" data-id="element-1581" data-mp="2uz4cdkvejvg8">
                <p className="text-sm font-bold text-ville-navy" data-id="element-1582" data-mp="2z0fwjaviboh1">{item.eyebrow}</p>
                <p className="text-xs text-slate-500" data-id="element-1583" data-mp="2yy3eyytnvg4i">{item.detail}</p>
              </li>)}
          </ul>
        </div>

        <nav className="mt-4 flex items-end justify-between border-t border-slate-100 px-5 pb-5 pt-3" data-id="element-1584" data-mp="38qsp9qdh6ny9">
          {[{
          icon: HomeIcon,
          label: 'Accueil',
          active: true
        }, {
          icon: IdCardIcon,
          label: 'Carte',
          active: false
        }].map(tab => <span key={tab.label} className={`flex w-12 flex-col items-center gap-1 text-[10px] font-semibold ${tab.active ? 'text-ville-navy' : 'text-slate-400'}`} data-id="element-1585" data-mp="3iq9phs9yk9mu">
              <tab.icon className="h-5 w-5" data-id="element-1586" data-mp="1scsnsayzeq8w" />
              {tab.label}
            </span>)}

          <span className="flex w-12 flex-col items-center gap-1 text-[10px] font-bold text-ville-indigo" data-id="element-1587" data-mp="1xc5dd3h8mbf6">
            <span className="grid h-11 w-11 -translate-y-2 place-items-center rounded-full bg-ville-indigo text-white shadow-lg shadow-ville-indigo/40" data-id="element-1588" data-mp="1pscxcpoj7are">
              <SparklesIcon className="h-5 w-5" data-id="element-1589" data-mp="1g1rqkeypezxe" />
            </span>
            <span className="-mt-1" data-id="element-1590" data-mp="1g21fdz80j11i">ATNA</span>
          </span>

          {[{
          icon: LayoutGridIcon,
          label: 'Services'
        }, {
          icon: UserRoundIcon,
          label: 'Profil'
        }].map(tab => <span key={tab.label} className="flex w-12 flex-col items-center gap-1 text-[10px] font-semibold text-slate-400" data-id="element-1591" data-mp="28o2ykaon4348">
              <tab.icon className="h-5 w-5" data-id="element-1592" data-mp="1yrq77jgki1cn" />
              {tab.label}
            </span>)}
        </nav>
      </div>
    </div>;
}